import { combineReducers } from "redux";
import AuthReducer from "./authReducer";
import MatchReducer from "./matchReducer";
import userMatchMappingReducer from "./userMatchMappingReducer";
import matchStringReducer from "./matchStringReducer";
import analysisReducer from "./analysisReducer";
import controlReducer from "./controlReducer";
import adminReducer from "./adminReducer";

import { withReduxStateSync } from "redux-state-sync";

const rootReducer = combineReducers({
  auth: AuthReducer,
  match: MatchReducer,
  userMatchMapping: userMatchMappingReducer,
  matchString: matchStringReducer,
  analysis: analysisReducer,
  control: controlReducer,
  admin: adminReducer,
});

export default withReduxStateSync(rootReducer);
